module.exports = __webpack_public_path__ + "static/media/lato-black.754d609d.eot";